// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpCombobox } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Combobox = wrap(jpCombobox(), {
    events: {
        onChange: 'change',
        onInput: 'input'
    }
});
// @ts-expect-error unknown property
Combobox.displayName = 'Jupyter.Combobox';
